import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import WithEscNavigation from '@hobs/hocs/WithEscNavigation';
import { createLoadingSelector } from '@hobs/utils/loading';
import _ChangeHistory from '@hobs/containers/ChangeHistory';
import { getTickets, clearTickets } from '@hobs/actions/tickets';
import { SERVICE_REQUEST_NAVIGATION_ORIGIN } from '@hobs/utils/constants';

import { getFooter, clearFooter } from '@hobs/actions/serviceRequests';

class ChangeHistory extends _ChangeHistory {
  getBackNavigationUrl = navContext => {
    if (navContext === SERVICE_REQUEST_NAVIGATION_ORIGIN.Tickets) {
      return '/tickets';
    } else {
      return '/requested-services';
    }
  };

  getHistoryPath() {
    const { match } = this.props;
    return `/${
      this.isCustom()
        ? 'custom-service-request-history'
        : 'service-request-history'
    }/${match.params.serviceRequestId}`;
  }

  getEditPath() {
    const { match } = this.props;
    return `/${
      this.isCustom() ? 'custom-service-request' : 'service-request'
    }/${match.params.serviceRequestId}`;
  }

  getChangeHistoryPath() {
    const { match } = this.props;
    return `/service-request/${match.params.serviceRequestId}/change-history`;
  }

  getShowPath() {
    return null;
  }

  getTransportationPath() {
    const { match } = this.props;
    return `/service-request/${match.params.serviceRequestId}/transportation`;
  }

  getDiscussionInitials() {
    const { t } = this.props;
    return t('HN');
  }

  onAddChangeRequest = () => {
    const {
      history,
      match: {
        params: { serviceRequestId }
      }
    } = this.props;

    history.push({
      pathname: `/${
        this.isCustom() ? 'custom-service-request' : 'service-request'
      }/${serviceRequestId}`,
      state: {
        showCreateChangeRequestDialog: true
      }
    });
  };

  onRequestForCancellation = () => {
    const {
      history,
      match: {
        params: { serviceRequestId }
      }
    } = this.props;

    history.push({
      pathname: `/${
        this.isCustom() ? 'custom-service-request' : 'service-request'
      }/${serviceRequestId}`,
      state: {
        showRequestCancellationDialog: true
      }
    });
  };
}

const oDataLoading = createLoadingSelector(['Tickets/Get']);

const mapStateToProps = state => ({
  isLoading: oDataLoading(state),
  tickets: state.tickets.tickets,
  footer: state.serviceRequests.footer,
  currentExercise: state.exercise.current
});

const mapDispatchToProps = {
  getTickets,
  clearTickets,
  getFooter,
  clearFooter
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withRouter(WithEscNavigation(ChangeHistory))));
